import { useLoad } from '../../../lib/useLoad';
import { api } from '../../../lib/api';
import type { GmLearner } from '../model/types';
import { clockOffset } from '../model/flow';

/**
 * `GET /app/grand-mock` plus the server clock offset (measured when the answer arrives), so
 * countdowns follow the server clock and not a wrong phone clock.
 */
export function useGmLearner() {
  const r = useLoad(async () => {
    const dto = await api<GmLearner>('GET', '/app/grand-mock');
    return { dto, offset: dto.grandMock ? clockOffset(dto.grandMock.serverTime, Date.now()) : 0 };
  }, []);
  return {
    data: r.data?.dto ?? null,
    offset: r.data?.offset ?? 0,
    error: r.error,
    reload: r.reload,
  };
}
